import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6559d2b6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "section__padding" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("Trading History")
const _hoisted_3 = { id: "grid-table" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "header-row" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "header-item" }, [
    /*#__PURE__*/_createElementVNode("div", null, "Time"),
    /*#__PURE__*/_createElementVNode("div", null, "Regulation"),
    /*#__PURE__*/_createElementVNode("div", null, "Price"),
    /*#__PURE__*/_createElementVNode("div", null, "Volume"),
    /*#__PURE__*/_createElementVNode("div", null, "Seller"),
    /*#__PURE__*/_createElementVNode("div", null, "Period")
  ])
], -1))
const _hoisted_5 = { class: "content-row" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_text = _resolveComponent("ion-text")!
  const _component_ion_card_content = _resolveComponent("ion-card-content")!
  const _component_ion_card = _resolveComponent("ion-card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_ion_text, { style: {"font-size":"1.5rem"} }, {
      default: _withCtx(() => [
        _hoisted_2
      ]),
      _: 1
    }),
    _createVNode(_component_ion_card, null, {
      default: _withCtx(() => [
        _createVNode(_component_ion_card_content, null, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_3, [
              _hoisted_4,
              _createElementVNode("div", _hoisted_5, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.trades, (trade, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "content-item",
                    key: index
                  }, [
                    _createElementVNode("div", null, _toDisplayString(_ctx.Helpers.formatDate(trade.created)), 1),
                    _createElementVNode("div", null, _toDisplayString(trade.regulationType), 1),
                    _createElementVNode("div", null, _toDisplayString(trade.unitPrice) + " NOK", 1),
                    _createElementVNode("div", null, _toDisplayString(trade.quantity * 1000) + " KW/h", 1),
                    _createElementVNode("div", null, _toDisplayString(trade.supplierOrganizationId
                    ? trade.supplierOrganizationId
                    : "null"), 1),
                    _createElementVNode("div", null, [
                      _createTextVNode(_toDisplayString(_ctx.Helpers.formatDate(trade.periodFrom)) + " ", 1),
                      _hoisted_6,
                      _createTextVNode(_toDisplayString(_ctx.Helpers.formatDate(trade.periodTo)), 1)
                    ])
                  ]))
                }), 128))
              ])
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}